import React, { Fragment } from "react";
import propTypes from "prop-types";
import { LaneAllocationRule, LaneAllocationRuleTypes } from "../../../../logic/api";
import flex from "../../../../styles/flex";
import SwitchField from "../../../../components/editable/EditableField/fields/SwitchField";
import { FiTrash } from "react-icons/fi";
import { IconButton } from "@mui/material";
import MoneyInputField from "../../../../components/editable/EditableField/fields/MoneyInputField";
import { useTranslation } from "react-i18next";


const LaneAllocationRuleList: React.FunctionComponent<{
    type: LaneAllocationRuleTypes;
    rules: LaneAllocationRule[] | null | undefined;
    onCreate: (rule: LaneAllocationRule,) => void;
    onChange: (rule: LaneAllocationRule,) => void;

    renderItem: (item: LaneAllocationRule, index: number) => React.ReactNode;
}> = (props) => {


    if (props.type == null) {
        return <Fragment></Fragment>
    }

    const createNewRule = () => {

        const rule: LaneAllocationRule = {
            type: props.type,
            active: true,
            duration: 1,
            priority: 0,
        };
        props.onCreate(rule);
    }

    const { t } = useTranslation();

    return (
        <div style={{ border: "solid 1px #eee" }}>

            {(props.rules ?? []).map((rule, i) => {
                if (rule.type != props.type || rule.deleted == true) {
                    return <Fragment key={i} />;
                }
                const child = props.renderItem(rule, i);

                return (
                    <div key={i} style={{ ...flex.flexRows, opacity: rule.active ? 1 : 0.5 }}>
                        <div style={{ ...flex.flexAuto, paddingLeft: 15, paddingTop: 5, }}>
                            <IconButton
                                onClick={() => {
                                    if (confirm(t("kmos.labels.confirmRuleDelete"))) {
                                        rule.deleted = true;
                                        props.onChange(rule);
                                    }

                                }}>
                                <FiTrash />
                            </IconButton>
                        </div>
                        <div style={{ ...flex.flexAuto, fontWeight: "bold", paddingTop: 10, paddingLeft: 5, }}>
                            <SwitchField value={rule.active == true} onChange={(v) => {
                                rule.active = v;
                                props.onChange(rule);
                            }}></SwitchField>
                        </div>
                        <div style={{ ...flex.flexAuto, fontWeight: "bold", paddingTop: 10, paddingRight: 20, paddingLeft: 10, }}>
                            <MoneyInputField maxWidth={60} value={rule.priority} label={t("kmos.labels.priority")} onChange={(p) => {
                                rule.priority = p;
                                props.onChange(rule);
                            }}></MoneyInputField>

                        </div>
                        {child}

                    </div>
                );
            })}
            {(props.rules != null && props.rules.length == 0) && (<div style={{ color: "#333", padding: 10, }}>{t("kmos.labels.noRulesConfig")}</div>)}

            <div style={{ textAlign: "right" }}>
                <div onClick={() => createNewRule()} style={{ color: "#333", padding: 10, textDecoration: "underline", cursor: "pointer" }}>{t("kmos.labels.addNewRule")}</div>
            </div>
        </div>
    );
}

LaneAllocationRuleList.propTypes = {
    type: propTypes.any.isRequired,
    rules: propTypes.any,
    renderItem: propTypes.func.isRequired,
    onCreate: propTypes.func.isRequired,
    onChange: propTypes.func.isRequired,

}

export default LaneAllocationRuleList;
